import React from 'react'
import EntityRow from './EntityRow'
import * as entityHeading from '../../../Constants/Constants'
import Style from '../manageEntities.module.css'
const StateBlock = ({ children }) => <div className={Style.stateBlock}>{children}</div>
const EntityList = ({
    entities,
    totalCount,
    isLoading,
    loadError,
    savingId,
    canManage,
    searchTerm,
    onToggle,
    onRetry,
    onClearSearch,
    sourceShortName,
    targetShortName
}) => {
    const inboundLabel = sourceShortName && targetShortName ? `${targetShortName} → ${sourceShortName}` : entityHeading.entityHeading.targetToSource
    const outboundLabel = sourceShortName && targetShortName ? `${sourceShortName} → ${targetShortName}` : entityHeading.entityHeading.sourceToTarget
    if (isLoading) {
        return (
            <StateBlock>
                <span className={Style.inlineSpinner} aria-hidden="true" />
                <p className={Style.stateText}>Loading entities...</p>
            </StateBlock>
        )
    }

    if (loadError) {
        return (
            <StateBlock>
                <i className={`uil-exclamation-octagon ${Style.stateIconError}`} aria-hidden="true" />
                <p className={Style.stateText}>{loadError}</p>
                <button type="button" className={Style.retryButton} onClick={onRetry}>
                    Try again
                </button>
            </StateBlock>
        )
    }

    if (totalCount === 0) {
        return (
            <StateBlock>
                <i className={`uil-database ${Style.stateIcon}`} aria-hidden="true" />
                <p className={Style.stateText}>No entities available</p>
                <p className={Style.stateHint}>They appear once the connector setup is complete.</p>
            </StateBlock>
        )
    }

    if (entities.length === 0) {
        return (
            <StateBlock>
                <i className={`uil-search ${Style.stateIcon}`} aria-hidden="true" />
                <p className={Style.stateText}>No entity matches &quot;{searchTerm}&quot;</p>
                <button type="button" className={Style.retryButton} onClick={onClearSearch}>
                    Clear search
                </button>
            </StateBlock>
        )
    }

    return (
        <div className={Style.tableScroll}>
            <table className={Style.table}>
                <thead>
                    <tr>
                        <th scope="col">{entityHeading.entityHeading.entityName}</th>
                        <th scope="col">{inboundLabel}</th>
                        <th scope="col">{outboundLabel}</th>
                        <th scope="col">{entityHeading.entityHeading.packetSize}</th>
                        <th scope="col">{entityHeading.entityHeading.lastUpdate}</th>
                    </tr>
                </thead>
                <tbody>
                    {entities.map((entity) => (
                        <EntityRow
                            key={entity.id}
                            entity={entity}
                            isSaving={savingId === entity.id}
                            canManage={canManage}
                            onToggle={onToggle}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default EntityList
